import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';

export class ShiftTypeService {
   async getShiftTypes() {
      return await http.get(`/shift-types`, cacheFirstConfig).then((response: any) => response.data.data);
   }
}
